// Paths of the belegleser service, relative to BelegleserConfig.apiBaseUrl — not the
// Softline connection.

export const BELEGLESER_API_JOBS = '/jobs';
export const BELEGLESER_API_JOB = '/jobs/{{jobId}}';
export const BELEGLESER_API_JOB_PAGES = '/jobs/{{jobId}}/pages';
export const BELEGLESER_API_JOB_PAGE = '/jobs/{{jobId}}/pages/{{page}}';
export const BELEGLESER_API_JOB_WORDS = '/jobs/{{jobId}}/words';
export const BELEGLESER_API_JOB_BOX_TEXT = '/jobs/{{jobId}}/box-text';
export const BELEGLESER_API_JOB_FILE = '/jobs/{{jobId}}/file';
export const BELEGLESER_API_JOB_TEMPLATE_PREVIEW = '/jobs/{{jobId}}/template/preview';
export const BELEGLESER_API_JOB_TEMPLATE = '/jobs/{{jobId}}/template';
export const BELEGLESER_API_JOB_FINAL_RESULT = '/jobs/{{jobId}}/final-result';
export const BELEGLESER_API_PLAUSIBILITY = '/plausibility';
export const BELEGLESER_API_HEALTH = '/health';
